import React from 'react';

import CoproKeyFigures from '../../components/Analyzing/CoproKeyFigures/CoproKeyFigures.module';

function CoproKeyFiguresView() {
  return (
    <CoproKeyFigures />
  );
}

export default CoproKeyFiguresView;





